// coffeelint: disable
var mod;

mod = angular.module('gym.eventOccurrance', ['model']);

mod.factory('EventOccurrance', [
  'Model',
  '$http',
  '$q',
  function(Model,
  http,
  q) {
    var EventOccurance,
  EventOccuranceBooking;
    EventOccuranceBooking = (function() {
      class EventOccuranceBooking extends Model {
        constructor() {
          super(...arguments);
        }

        gym() {
          return this.event().gym();
        }

      };

      EventOccuranceBooking.param = 'booking';

      EventOccuranceBooking.prototype.event = EventOccuranceBooking.prototype.parent;

      return EventOccuranceBooking;

    }).call(this);
    return EventOccurance = (function() {
      class EventOccurance extends Model {
        constructor() {
          super(...arguments);
          this.bookings = this.wrapPaginated('bookings', EventOccuranceBooking);
        }

        gymId() {
          return this.gym().id();
        }

        // we're overriding this because when we hit the server
        // we actually need to supply some extra info due to
        // the hackery that we've had to engage in to make this
        // work
        delete() {
          var removeFromCol;
          removeFromCol = () => {
            var col;
            if (col = this.collection()) {
              return col.remove(col.indexOf(this));
            }
          };
          if (this.isNew()) {
            return q.when(null).then(removeFromCol);
          } else {
            return http({
              method: 'DELETE',
              url: this.link('self'),
              data: {
                edit_type: this.attributes.edit_type
              }
            }).then(removeFromCol);
          }
        }

      };

      EventOccurance.param = 'event';

      EventOccurance.prototype.gym = EventOccurance.prototype.parent;

      return EventOccurance;

    }).call(this);
  }
]);

// coffeelint: enable
